import { render, staticRenderFns } from "./LabelPanel.vue?vue&type=template&id=5d9c4f41&scoped=true"
import script from "./LabelPanel.vue?vue&type=script&lang=ts"
export * from "./LabelPanel.vue?vue&type=script&lang=ts"
import style0 from "./LabelPanel.vue?vue&type=style&index=0&id=5d9c4f41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9c4f41",
  null
  
)

export default component.exports